import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  LEADS_REFRESH: createSagaAction('LEADS_REFRESH'),
  CREATE_LEAD: createSagaAction('CREATE_LEAD')
}

// Action Creators
export const actions = {
  leadsRefresh: ({ status }) => ({ type: constants.LEADS_REFRESH.ACTION, status }),
  createLead: ({ content, userId }) => ({ type: constants.CREATE_LEAD.ACTION, content, userId })
}

// Reducer
const initialState = [
  {
    name: ''
  }
]

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    default:
      return state
    case constants.LEADS_REFRESH.SUCCESS:
      return { ...state, payload }
    case constants.CREATE_LEAD.SUCCESS:
      return { ...state, payload }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/leadsActions.js